import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
// import { toast } from "react-toastify";

const baseUrl = "https://atcgn.lkm.accenture.com/atcgn-api";
// const baseUrl = "http://localhost:1111";


export const AdminSlice = createSlice({
  name: "admin",
  initialState: {
    sessions: [],
    isLoading: false,
    error: null,
    success: false,
    timeZone:[]
    
  },
  reducers: {
    setSessions: (state, { payload }) => {
      state.sessions = Array.isArray(payload) ? payload : [];
      state.error = null;
    },
    setLoading: (state, { payload }) => {
      state.isLoading = payload;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
    setSuccess: (state, { payload }) => {
      state.success = payload;
    },
    setTimeZone: (state,{payload}) => {
      state.timeZone = Array.isArray(payload) ? payload : [] ;
      state.error = null;
    }
  },
});

export const { setSessions, setLoading, setError, setSuccess,setTimeZone } =
  AdminSlice.actions;
export default AdminSlice.reducer;

export const fetchSessions = () => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const res = await axios.get(`${baseUrl}/sessions`, {
      headers: {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    });
    console.log("API response:", res.data);
    dispatch(setSessions(res.data));
  } catch (err) {
    dispatch(setError("Failed to fetch sessions"));
    console.error(err);
  } finally {
    dispatch(setLoading(false));
  }
};
export const fetchTimeZone = () => async(dispatch)=>{
   dispatch(setLoading(true));
  try {
    const res = await axios.get(`${baseUrl}/timeZone`, {
      headers: {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    });
    console.log("API response:", res.data);
    dispatch(setTimeZone(res.data));
  }
  catch (err) {
    dispatch(setError("Failed to fetch sessions"));
    console.error(err);
  } finally {
    dispatch(setLoading(false));
  }
}

export const uploadFile = (formData) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const res = await axios.post(`${baseUrl}/upload`, formData, {
      headers: {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
      },
    });
    console.log("res.data",res.data)
    if(res.data.message ==="All records already exist"){
         toast.warn(res.data.message,{
                style:{
                backgroundColor:'white',
                color:'#808080',
                border:" 1.5px solid #f2c037",
                borderRadius:'0px',
                borderLeft:'5px solid #f2c037'
                
            },
                icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#f2c037"   // yellow/orange
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" /> {/* vertical line */}
      <circle cx="12" cy="16" r="1" />        {/* dot */}
    </svg>
  )
            })
    }
    else{
       toast.success("Data added successfully!", {
                    style: {
                        backgroundColor: 'white',
                        color: '#808080',
                        border: " 1.5px solid #21d4c7",
                        borderRadius: '0px',
                        borderLeft: '5px solid #21d4c7'

                    },
                    icon: <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#21d4c7"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <circle cx="12" cy="12" r="10" />   {/* outlined circle */}
                        <path d="M9 12l2 2 4-4" />           {/* check */}
                    </svg>
                })
    }
    // dispatch(setSessions(res.data));
    dispatch(fetchSessions());
    dispatch(setSuccess(true));
  } catch (err) {
    const coursename = `Duplicate entry of ${err?.response.data.message?.split("'")[1].split('-')[0]} `
    toast.error(coursename,{
         style:{
                backgroundColor:'white',
                color:'#808080',
                border:" 1.5px solid #e74c3c",
                borderRadius:'0px',
                borderLeft:'5px solid #e74c3c'
                
            },
        icon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#e74c3c"   // red
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="15" y1="9" x2="9" y2="15" />
      <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
  )
    })
    dispatch(setError(err.response.data.message ||"Upload failed"));
  } finally {
    dispatch(setLoading(false));
  }
};

export const downloadFile =
  (filters = {}) =>
  async (dispatch) => {
    try {
      const params = {};

      if (filters.capability) params.capability = filters.capability;
      if (filters.category) params.category = filters.category;
      if (filters.modeDelivery) params.modeDelivery = filters.modeDelivery;
      if (filters.targetAudience)
        params.targetAudience = filters.targetAudience;
      if (filters.searchTerm) params.search = filters.searchTerm;
      if (filters.startDate) params.startDate = filters.startDate.toISOString();
      if (filters.endDate) params.endDate = filters.endDate.toISOString();

      const response = await axios.get(`${baseUrl}/download`, {
        params,
        responseType: "blob",
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "ATCGN_Calendar_Data.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();

      dispatch(setSuccess(true));
    } catch (err) {
      dispatch(setError("Download failed"));
      console.error(err);
    }
  };
